var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LESS_WATER",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74.203,
    viewBox: "0 0 74 74.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #LESS_WATER .cls-1 {\n        fill: #ff7600;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1073.212 -710.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_529",
    "data-name": "Pfad 529",
    className: "cls-1",
    d: "M1110.212,710.482a37.1,37.1,0,1,0,37,37.1A37.051,37.051,0,0,0,1110.212,710.482Zm0,4.639a32.131,32.131,0,0,1,20.324,7.236l-12.3,12.3c-3.536-6-7.035-11.024-7.072-11.079l-.948-1.355-.946,1.353c-.592.844-14.414,20.678-14.684,29.2l-.026.257a15.725,15.725,0,0,0,.7,4.6L1085,767.89a32.449,32.449,0,0,1,25.208-52.769Zm-13.336,38.041.023-.234c.093-6.528,10.145-21.936,13.32-26.642,1.323,1.966,3.841,5.8,6.327,10.062l-19.37,19.367A13.484,13.484,0,0,1,1096.876,753.161Zm13.336,26.885a32.131,32.131,0,0,1-20.322-7.236l9.719-9.717a1.155,1.155,0,0,0,.074,1.617,15.54,15.54,0,0,0,1.986,1.554,1.135,1.135,0,0,0,.636.194,1.156,1.156,0,0,0,.636-2.12,13.383,13.383,0,0,1-1.686-1.327,1.159,1.159,0,0,0-1.61.044l20.667-20.664a1.136,1.136,0,0,0,.014.953c.342.7.67,1.4.973,2.079a1.156,1.156,0,0,0,2.114-.939c-.317-.71-.652-1.432-1.01-2.155a1.15,1.15,0,0,0-1.48-.548l14.5-14.5a32.447,32.447,0,0,1-25.211,52.767Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_530",
    "data-name": "Pfad 530",
    className: "cls-1",
    d: "M1090.7,734.931a13.36,13.36,0,0,1-2.116-.377,1.157,1.157,0,0,0-.592,2.236,15.928,15.928,0,0,0,2.481.444c.039,0,.076,0,.116,0a1.157,1.157,0,0,0,.111-2.308Z",
    transform: "translate(18.265 31.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_531",
    "data-name": "Pfad 531",
    className: "cls-1",
    d: "M1095.509,726.826a1.153,1.153,0,0,0-.772,1.441,16.476,16.476,0,0,1,.507,2.121,1.158,1.158,0,0,0,1.14.974,1.256,1.256,0,0,0,.185-.014,1.161,1.161,0,0,0,.96-1.325,19.044,19.044,0,0,0-.578-2.424A1.155,1.155,0,0,0,1095.509,726.826Z",
    transform: "translate(28.185 21.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_532",
    "data-name": "Pfad 532",
    className: "cls-1",
    d: "M1096.621,729.79a1.164,1.164,0,0,0-1.38.879,13.359,13.359,0,0,1-.631,2.063,1.159,1.159,0,0,0,.657,1.5,1.124,1.124,0,0,0,.421.079,1.16,1.16,0,0,0,1.078-.733,16.27,16.27,0,0,0,.733-2.405A1.159,1.159,0,0,0,1096.621,729.79Z",
    transform: "translate(27.979 25.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_533",
    "data-name": "Pfad 533",
    className: "cls-1",
    d: "M1093.065,734.333a12.793,12.793,0,0,1-2.04.659,1.157,1.157,0,0,0,.261,2.285,1.132,1.132,0,0,0,.261-.03,15.214,15.214,0,0,0,2.407-.777,1.157,1.157,0,1,0-.89-2.137Z",
    transform: "translate(22.204 31.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_534",
    "data-name": "Pfad 534",
    className: "cls-1",
    d: "M1094.7,732.881a13.387,13.387,0,0,1-1.5,1.535,1.157,1.157,0,0,0,1.522,1.744,16.167,16.167,0,0,0,1.76-1.8,1.156,1.156,0,1,0-1.781-1.475Z",
    transform: "translate(25.709 28.851)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessWater);
export default __webpack_public_path__ + "static/media/less-water.a563bbe4c4e92f18cfeb676cab4f5966.svg";
export { ForwardRef as ReactComponent };